import { toggleResetButton } from "../helpers/locations";
import { updateMap } from "../helpers/maps";

export const locationFilters = () => {
    // Show the popup
    const triggers = document.querySelectorAll('.js__show-regions-popup');

    if ( triggers.length ) {
        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => showRegionsPopup(trigger));
        });
    }
    
    // Close the popup -- This is handled in functions/popups.js file when using the close button

    // Filter the locations
    const filterSubmitButtons = document.querySelectorAll('.js__filter-regions');

    if ( filterSubmitButtons.length ) {
        filterSubmitButtons.forEach(button => {
            const popup = button.closest('.e__regions-popup');
            const parentModule = button.closest('.module');
            const locationsContainer = parentModule.querySelector('.js-loc-search-results-container');
            const locations = parentModule.querySelectorAll('.js-loc-card-region');
            const map = locationsContainer.querySelector('.js-loc-search-map');

            button.addEventListener('click', (event) => {
                event.preventDefault();

                const regions = popup.querySelectorAll('.e__regions-popup__toggle input:checked');

                // Update the active regions data attribute
                updateActiveRegions(regions, locationsContainer);

                // Filter the locations by the active regions
                filterLocationsByRegions(locations, regions, popup, locationsContainer);

                // Update the map
                updateMap(map);
            });
        });
    }
};

const showRegionsPopup = (trigger) => {
    const parentModule = trigger.closest('.module');
    const regionsPopup = parentModule.querySelector('.e__regions-popup');

    regionsPopup.classList.add('active');
    document.querySelector('body').classList.add('js__popup-active', 'js__regions-popup-active');
    document.querySelector('#js__body').classList.add('js__popup-active');     
};

const closeRegionsPopup = (popup) => {
    popup.classList.remove('active');
    document.querySelector('body').classList.remove('js__popup-active');
    document.querySelector('#js__body').classList.remove('js__popup-active', 'js__regions-popup-active');     
};

export const updateActiveRegions = (regions, locationsContainer) => {
    if ( regions ) {
        const activeRegions = Array.from(regions).map(region => region.value);

        // Update the active regions data attribute
        locationsContainer.dataset.activeRegions = activeRegions.join(',');

        // Clear any active locations data attribute
        locationsContainer.dataset.activeLocations = '';
    }
};

const filterLocationsByRegions = (locations, regions, popup, locationsContainer) => {   
    const map = locationsContainer.querySelector('.js-loc-search-map');

    // First hide all locations
    toggleAllLocations('hide', locations);

    // Loop through the locations for each region and show the ones for the active region filters
    let displayingRegions = 0;

    if ( regions.length ) {
        regions.forEach(region => {
            locations.forEach(location => {
                if ( location.dataset.region === region.value ) {
                    // Show the location
                    location.classList.remove('!hidden');

                    // Increment the displayingRegions counter
                    displayingRegions++;
                }
            });
        });	        
    } else {
        toggleAllLocations('show', locations);
    }

    // Show/hide the reset button
    const showResetButton = displayingRegions > 0;
    toggleResetButton(showResetButton, locationsContainer);

    // Close the popup
    closeRegionsPopup(popup);
};

const toggleAllLocations = (displayType, locations) => {
    if ( locations && locations.length ) {
        locations.forEach(location => {
            if ( displayType === 'hide') {
                location.classList.add('!hidden');
            }

            if ( displayType === 'show') {
                location.classList.remove('!hidden');
            }
        });
    }
};

export const resetRegionFilters = async (mod) => {
    const locationsContainer = mod.querySelector('.js-loc-search-results-container');
    const locations = locationsContainer.querySelectorAll('.js-loc-card-region');
    const popup = mod.querySelector('.e__regions-popup');

    const regions = popup.querySelectorAll('.e__regions-popup__toggle input:checked');

    // Show all locations
    toggleAllLocations('show', locations);

    // Uncheck all active region checkboxes
    if ( regions.length ) {
        regions.forEach(region => {
            region.checked = false;
        });
    }

    // Reset the active regions data attribute
    locationsContainer.dataset.activeRegions = '';
}